import { useContext } from "react";
import { AppContext, ContextProvider } from "../../../context/ContextProvider";
import { useLocation } from "react-router-dom";
import api from "../../../api";
import { provisionerStatuses } from "../../../context/helper";

export const useFetchClusterData = () => {
    const { setClusterTabSelected } = useContext(AppContext);
    const { openRightDrawer, setOpenRightDrawer, allClusters, setAllClusters, currentCluster, updateCluster, setUpdateCluster, setCurrentCluster, isUpdate, isOneClick, oneClickCluster, setOneClickCluster, clusterTabSelected, fetchingClusterPrerequisites, setFetchingClusterPrerequisites } = useContext(AppContext);
    let location = useLocation();
    const fetchClusterData = async (isUpdate, isOneClick, id) => {
        let myData = {};
        //if (isUpdate) {
        console.log("MYDATA: ", myData);
        console.log("isUpdate: ", isUpdate);
        let apiStr = isUpdate ? `${process.env.REACT_APP_API_URI}/api/cluster/cluster/${id}/` : `${process.env.REACT_APP_API_URI}/api/cluster/one-click-cluster/`;
        await api.get(apiStr).then((res) => {
            let data = res.data;
            if (data.status) {
                console.log("Data: ", data.data.cluster_data.environment);
                data.data.cluster_data.environment === 'default' ? setClusterTabSelected('existingVpc') : setClusterTabSelected(data.data.cluster_data.environment);
                data.data.cluster_data.environment === 'default' ? localStorage.setItem("clusterTabSelected", "existingVpc") : localStorage.setItem("clusterTabSelected", data.data.cluster_data.environment);
                let tags = [];
                tags = data.data.cluster_data.tags ? Object.entries(data.data.cluster_data.tags).map(([name, value]) => ({
                    name: name,
                    value: value
                })) : [{ name: "", value: "" }];
                tags = tags.filter(val => val.name !== "provider");
                tags = tags.length === 0 ? [{ name: "", value: "" }] : tags;
                console.log("data.data.addons_data: ", data);
                const addonsDataObj = data.data.addons_data || {};
                Object.entries(addonsDataObj).forEach(([key, val]) => {
                    val.name = key;
                    val.present = true;
                });

                const addonsData = Object.entries(data.data.addons_data || {});
                let selectedAddons = addonsData.filter(([key]) => key !== "_meta").map(([key, val]) => {
                    return {
                        id: key,
                        name: key,
                        present: true,
                        subText: val.chart_info,
                        recommended: val.is_recommended,
                        editable: isUpdate ? val.editable : true,
                        dependsOn: val.depends_on || [],
                        disabled: isOneClick ? true : false,
                        selected: true,
                        borderColor: "#f5f5f5",
                        message: ""
                    };
                });

                console.log('Selected addons: ', selectedAddons);
                console.log('addonsData in useFetchClusterData: ', addonsData);
                if (isOneClick || isUpdate) {
                    // localStorage.setItem('no_of_azs', data.data.pre_requsite_data.available_eip_quota);
                    localStorage.setItem('isRegionAvailable', "true");
                }

                if (data.data.cluster_data.environment === "prod") {

                    console.log("addonsData: ", addonsData)
                    // const pglInfo = addonsData.find(val => val.name === "grafana-stack");
                    const [, pglInfo] = addonsData.find(([key, val]) => key === "grafana-stack") || [];
                    const [, k8sInfo] = addonsData.find(([key, val]) => key === "kubernetes-dashboard") || [];
                    console.log("k8sInfo: ", k8sInfo)
                    myData = {
                        id: id,
                        title: data.data.display_name,
                        accountId: data.data.target_account_id,
                        integration: data.data.integration_type,
                        integrationId: isUpdate ? updateCluster.integrationId : data.data.cluster_data.integration_id,
                        alias: data.data.target_account_alias,
                        region: data.data.cluster_data.region,
                        nodeExists: data.data.cluster_data.is_node_group_exists || false,
                        accountType: "",
                        zonesAvailable: [],
                        selectedCluster: data.data,
                        isDataFetched: false,
                        accountType: "aws", //needs to be changed for multiple account types
                        availability_zones: isOneClick ? data.data.pre_requsite_data.availability_zones : [],
                        vpc: "Create New VPC",
                        vpcData: {},
                        prerequisiteInfo: isOneClick ? data.data.pre_requsite_data : {},
                        provisioner: data.data.cluster_data.provisioner,
                        prod: {
                            tags: tags,
                            naz: isOneClick ? [data.data.cluster_data.availability_zones] : data.data.cluster_data.availability_zones,
                            selectedAddons: selectedAddons,
                            publicSubnets: [],
                            privateSubnets: [],
                            subnets: [],
                            vpcCidr: data.data.cluster_data.vpc_cidr_block,
                            flowLogMax: "60",    // flow_log_max_aggregation_interval //Will be edited later
                            logRetention: data.data.cluster_data.vpc_flow_log ? data.data.cluster_data.vpc_flow_log_retention_period : "60",    // flow_log_cloudwatch_log_group_retention_in_days
                            clusterLogRetention: data.data.cluster_data.vpc_flow_log ? data.data.cluster_data.kubernetes_log_retention_period : "90",    // flow_log_cloudwatch_log_group_retention_in_days
                            endpointPublicAccess: isOneClick ? true : data.data.cluster_data.cluster_endpoint_public_access,
                            endpointPrivateAccess: isOneClick ? true : data.data.cluster_data.cluster_endpoint_private_access,
                            publicAccessCidr: "0.0.0.0/0",
                            versionsAvailable: [],
                            addonsData: {},
                            eks: data.data.cluster_data.kubernetes_version,
                            hostedZones: isUpdate ? [] : oneClickCluster[data.data.cluster_data.environment].hostedZones,
                            serverInsType: "",
                            instanceTypeMin: "",
                            instanceTypeMax: "",
                            backups: false,
                            natGatway: true,
                            vpns: true,
                            // vpcFlowLogs: data.data.cluster_data.vpc_flow_logs === "true" ? true : false,    // enable_flow_log
                            vpcFlowLogs: data.data.cluster_data.vpc_flow_log || false,    // enable_flow_log
                            enableLogTypes: true,
                            addonIds: {},
                            apiServer: isOneClick ? false : data.data.cluster_data.cluster_enabled_log_types ? data.data.cluster_data.cluster_enabled_log_types.includes("api") : false,
                            audit: isOneClick ? false : data.data.cluster_data.cluster_enabled_log_types ? data.data.cluster_data.cluster_enabled_log_types.includes("audit") : false,
                            authenticator: isOneClick ? false : data.data.cluster_data.cluster_enabled_log_types ? data.data.cluster_data.cluster_enabled_log_types.includes("authenticator") : false,
                            controllerManager: isOneClick ? false : data.data.cluster_data.cluster_enabled_log_types ? data.data.cluster_data.cluster_enabled_log_types.includes("controllerManager") : false,
                            scheduler: isOneClick ? false : data.data.cluster_data.cluster_enabled_log_types ? data.data.cluster_data.cluster_enabled_log_types.includes("scheduler") : false,
                            addons: {
                                argoFlow: addonsData.some(val => val.name === "argo-workflow"),
                                cert_manager_enabled: addonsData.some(val => val.name === "cert-manager"),
                                cert_manager_letsencrypt_email: "",
                                cert_manager_install_letsencrypt_http_issuers: false,
                                enable_karpenter: false,
                                karpenter_provisioner_enabled: false,
                                enable_cluster_autoscaler: true,
                                enable_cluster_propotional_autoscaler: false,
                                enable_single_az_ebs_gp3_storage_class: true,
                                create_efs_storage_class: addonsData.some(val => val.name === "EFS Storage Class"),
                                enable_amazon_eks_aws_ebs_csi_driver: true,
                                enable_amazon_eks_vpc_cni: true,
                                create_service_monitor_crd: true,
                                enable_reloader: addonsData.some(val => val.name === "reloader"),
                                enable_metrics_server: true,
                                enable_ingress_nginx: true,
                                enable_external_secrets: false,
                                enable_keda: addonsData.some(val => val.name === "Keda"),
                                enable_istio: false,
                                enable_aws_node_termination_handler: true,
                                nginx_alb_controler: addonsData.some(val => val.name === "Ingress ALB Controller"),
                                nginx_ingress_controler: addonsData.some(val => val.name === "Nginx Ingress Controller"),
                                pgl_stack: pglInfo ? true : false,
                                k8s_dashboard: k8sInfo ? true : false,

                                delete_k8s_dashboard: false //this field will be false by default. It will be true when the user manually disables the enabled k8s dashboard while updating the cluster
                            },
                            updateAddons: {
                                pgl_stack: pglInfo ? true : false,
                                // cert_manager_enabled: data.data.addons_list.some(val => val.name === "Grafana Stack"),
                                // nginx_ingress_controler: data.data.addons_list.some(val => val.name === "Grafana Stack")
                            },
                            grafanaStack: {
                                appName: isOneClick ? "" : pglInfo?.user_values?.app_name || "",
                                recordPrefix: isOneClick ? "" : pglInfo?.user_values?.record_prefix || "",
                                hostname: isOneClick ? "atmosly.in" : pglInfo?.user_values?.hosted_zone || "atmosly.in",
                                zoneId: isOneClick ? "" : pglInfo?.user_values?.zone_id || "",
                                dnsRecordType: isOneClick ? "" : pglInfo?.user_values?.dns_record_type || "",
                                loki: isOneClick ? true : pglInfo?.user_values?.loki_enabled === false ? false : true,
                                // cloudWatchCollector: isOneClick ? true : pglInfo?.user_values?.cloudwatch_enabled === false ? false : true,
                                cloudWatchCollector: pglInfo?.user_values?.cloudwatch_enabled === true ? true : false,
                                refreshInterval: isOneClick ? "30" : pglInfo?.user_values?.dashboard_refresh_interval?.split("s")[0] || "30",
                                objExpiration: "90",
                                hostedZonesList: [],
                                grafanaUser: isOneClick ? "" : pglInfo?.user_values?.grafana_user || "",
                                grafanaPassword: isOneClick ? "" : pglInfo?.user_values?.grafana_password || "",
                                // grafana toggle, node placement and Prometheus/Grafana
                                // resource sizing — hydrated from the saved user_values so
                                // the edit drawer reflects what was actually installed.
                                grafanaEnabled: isOneClick ? true : (pglInfo?.user_values?.grafana_enabled === false || pglInfo?.user_values?.grafana_enabled === "false") ? false : true,
                                nodeSelectorKey: isOneClick ? "" : Object.keys(pglInfo?.user_values?.node_selector || {})[0] || "",
                                nodeSelectorValue: isOneClick ? "" : Object.values(pglInfo?.user_values?.node_selector || {})[0] || "",
                                promCpuRequest: isOneClick ? "" : pglInfo?.user_values?.prometheus_cpu_request || "",
                                promCpuLimit: isOneClick ? "" : pglInfo?.user_values?.prometheus_cpu_limit || "",
                                promMemRequest: isOneClick ? "" : pglInfo?.user_values?.prometheus_memory_request || "",
                                promMemLimit: isOneClick ? "" : pglInfo?.user_values?.prometheus_memory_limit || "",
                                promStorage: isOneClick ? "" : pglInfo?.user_values?.prometheus_storage_size || "",
                                promRetention: isOneClick ? "" : pglInfo?.user_values?.prometheus_retention || "",
                                grafanaCpuRequest: isOneClick ? "" : pglInfo?.user_values?.grafana_cpu_request || "",
                                grafanaCpuLimit: isOneClick ? "" : pglInfo?.user_values?.grafana_cpu_limit || "",
                                grafanaMemRequest: isOneClick ? "" : pglInfo?.user_values?.grafana_memory_request || "",
                                grafanaMemLimit: isOneClick ? "" : pglInfo?.user_values?.grafana_memory_limit || "",
                            },
                            k8sDashboard: {
                                dnsRecordType: isOneClick ? "" : k8sInfo?.user_values?.dns_record_type,
                                hostedZonesList: [],
                                hostname: isOneClick ? "atmosly.in" : k8sInfo?.user_values?.hosted_zone || "atmosly.in",
                                recordPrefix: isOneClick ? "" : k8sInfo?.user_values?.record_prefix,
                                zoneId: isOneClick ? "" : k8sInfo?.user_values?.zone_id,
                            },
                            argoFlow: {
                                dnsRecordType: data.data?.addons_data['argo-workflow']?.user_values?.dns_record_type,
                                hostedZonesList: [],
                                hostname: data.data?.addons_data['argo-workflow']?.user_values?.hosted_zone,
                                recordPrefix: data.data?.addons_data['argo-workflow']?.user_values?.record_prefix,
                                zoneId: data.data?.addons_data['argo-workflow']?.user_values?.zone_id,
                            }
                        },
                        "non-prod": {
                            tags: [{ name: "", value: "" }],
                            naz: [],
                            selectedAddons: [],
                            publicSubnets: [],
                            privateSubnets: [],
                            subnets: [],
                            vpcCidr: "10.0.0.0/16",
                            flowLogMax: "600",     // flow_log_max_aggregation_interval
                            logRetention: "60",     // flow_log_cloudwatch_log_group_retention_in_days
                            clusterLogRetention: "90",  // cluster_log_retention_in_days
                            eks: "",
                            hostedZones: [],
                            serverInsType: "",
                            instanceTypeMin: "",
                            instanceTypeMax: "",
                            endpointPublicAccess: true,
                            endpointPrivateAccess: true,
                            publicAccessCidr: "0.0.0.0/0",
                            versionsAvailable: [],
                            addonsData: {},
                            backups: false,
                            natGatway: true,
                            vpns: true,
                            vpcFlowLogs: false,    // enable_flow_log
                            enableLogTypes: false,
                            addonIds: {},
                            apiServer: false,
                            audit: false,
                            authenticator: false,
                            controllerManager: false,
                            scheduler: false,
                            addons: {
                                argoFlow: addonsData.some(val => val.name === "argo-workflow"),
                                cert_manager_enabled: true,
                                cert_manager_letsencrypt_email: "",
                                cert_manager_install_letsencrypt_http_issuers: false,
                                enable_karpenter: false,
                                karpenter_provisioner_enabled: false,
                                enable_cluster_autoscaler: true,
                                enable_cluster_propotional_autoscaler: false,
                                enable_single_az_ebs_gp3_storage_class: true,
                                create_efs_storage_class: false,
                                enable_amazon_eks_aws_ebs_csi_driver: true,
                                enable_amazon_eks_vpc_cni: true,
                                create_service_monitor_crd: true,
                                enable_reloader: false,
                                enable_metrics_server: true,
                                enable_ingress_nginx: true,
                                enable_external_secrets: false,
                                enable_keda: false,
                                enable_istio: false,
                                enable_aws_node_termination_handler: true,
                                nginx_alb_controler: false,
                                nginx_ingress_controler: true,
                                pgl_stack: true,
                                k8s_dashboard: true,

                                delete_k8s_dashboard: false //this field will be false by default. It will be true when the user manually disables the enabled k8s dashboard while updating the cluster
                            },
                            updateAddons: {},
                            grafanaStack: {
                                appName: "",
                                recordPrefix: "",
                                hostname: "atmosly.in",
                                zoneId: "",
                                dnsRecordType: "",
                                loki: true,
                                cloudWatchCollector: false,
                                refreshInterval: "30",
                                objExpiration: "90",
                                hostedZonesList: [],
                                grafanaUser: "",
                                grafanaPassword: ""
                            },
                            k8sDashboard: {
                                dnsRecordType: "",
                                hostedZonesList: [],
                                hostname: "atmosly.in",
                                recordPrefix: "",
                                zoneId: "",
                            },
                            argoFlow: {
                                dnsRecordType: "",
                                hostedZonesList: [],
                                hostname: "atmosly.in",
                                recordPrefix: "",
                                zoneId: "",
                            }
                        },
                        dev: {
                            tags: [{ name: "", value: "" }],
                            naz: [],
                            selectedAddons: [],
                            publicSubnets: [],
                            privateSubnets: [],
                            subnets: [],
                            vpcCidr: "",
                            flowLogMax: "0",
                            logRetention: "60",
                            clusterLogRetention: "90",
                            endpointPublicAccess: true,
                            endpointPrivateAccess: true,
                            publicAccessCidr: "0.0.0.0/0",
                            versionsAvailable: [],
                            addonsData: {},
                            eks: "",
                            hostedZones: [],
                            serverInsType: "",
                            instanceTypeMin: "",
                            instanceTypeMax: "",
                            backups: false,
                            natGatway: false,
                            vpns: false,
                            vpcFlowLogs: false,
                            enableLogTypes: false,
                            addonIds: {},
                            apiServer: false,
                            audit: false,
                            authenticator: false,
                            controllerManager: false,
                            scheduler: false,
                            addons: {
                                argoFlow: true,
                                cert_manager_enabled: true,
                                cert_manager_letsencrypt_email: "",
                                cert_manager_install_letsencrypt_http_issuers: false,
                                enable_karpenter: false,
                                karpenter_provisioner_enabled: false,
                                enable_cluster_autoscaler: true,
                                enable_cluster_propotional_autoscaler: false,
                                enable_single_az_ebs_gp3_storage_class: true,
                                create_efs_storage_class: false,
                                enable_amazon_eks_aws_ebs_csi_driver: true,
                                enable_amazon_eks_vpc_cni: true,
                                create_service_monitor_crd: true,
                                enable_reloader: false,
                                enable_metrics_server: true,
                                enable_ingress_nginx: true,
                                enable_external_secrets: false,
                                enable_keda: false,
                                enable_istio: false,
                                enable_aws_node_termination_handler: true,
                                nginx_alb_controler: false,
                                nginx_ingress_controler: true,
                                pgl_stack: false,
                                k8s_dashboard: false,

                                delete_k8s_dashboard: false //this field will be false by default. It will be true when the user manually disables the enabled k8s dashboard while updating the cluster
                            },
                            updateAddons: {},
                            grafanaStack: {
                                appName: "",
                                recordPrefix: "",
                                hostname: "atmosly.in",
                                zoneId: "",
                                dnsRecordType: "",
                                loki: true,
                                cloudWatchCollector: false,
                                refreshInterval: "30",
                                objExpiration: "90",
                                hostedZonesList: [],
                                grafanaUser: "",
                                grafanaPassword: ""
                            },
                            k8sDashboard: {
                                dnsRecordType: "",
                                hostedZonesList: [],
                                hostname: "atmosly.in",
                                recordPrefix: "",
                                zoneId: "",
                            },
                            argoFlow: {
                                dnsRecordType: "",
                                hostedZonesList: [],
                                hostname: "atmosly.in",
                                recordPrefix: "",
                                zoneId: "",
                            }
                        },
                        existingVpc: {
                            tags: [{ name: "", value: "" }],
                            selectedAddons: [],
                            naz: [],
                            publicSubnets: [],
                            privateSubnets: [],
                            subnets: [],
                            hostedZones: [],
                            vpcCidr: "10.0.0.0/16",
                            flowLogMax: "60",    // flow_log_max_aggregation_interval
                            logRetention: "60",    // flow_log_cloudwatch_log_group_retention_in_days
                            clusterLogRetention: "90",    // cluster_log_retention_in_days
                            endpointPublicAccess: true,
                            endpointPrivateAccess: true,
                            publicAccessCidr: "0.0.0.0/0",
                            versionsAvailable: [],
                            addonsData: {},
                            eks: "",
                            serverInsType: "",
                            instanceTypeMin: "",
                            instanceTypeMax: "",
                            backups: false,
                            natGatway: true,
                            vpns: true,
                            vpcFlowLogs: true,    // enable_flow_log
                            enableLogTypes: true,
                            addonIds: {},
                            apiServer: false,
                            audit: false,
                            authenticator: false,
                            controllerManager: false,
                            scheduler: false,
                            addons: {
                                cert_manager_enabled: false,
                                cert_manager_letsencrypt_email: "",
                                cert_manager_install_letsencrypt_http_issuers: false,
                                enable_karpenter: false,
                                karpenter_provisioner_enabled: false,
                                enable_cluster_autoscaler: true,
                                enable_cluster_propotional_autoscaler: false,
                                enable_single_az_ebs_gp3_storage_class: true,
                                create_efs_storage_class: false,
                                enable_amazon_eks_aws_ebs_csi_driver: true,
                                enable_amazon_eks_vpc_cni: true,
                                create_service_monitor_crd: true,
                                enable_reloader: false,
                                enable_metrics_server: true,
                                enable_ingress_nginx: true,
                                enable_external_secrets: false,
                                enable_keda: false,
                                enable_istio: false,
                                enable_aws_node_termination_handler: true,
                                nginx_alb_controler: false,
                                nginx_ingress_controler: true,
                                pgl_stack: true,
                                k8s_dashboard: true,
                                argoFlow: true,

                                delete_k8s_dashboard: false //this field will be false by default. It will be true when the user manually disables the enabled k8s dashboard while updating the cluster
                            },
                            grafanaStack: {
                                appName: "",
                                recordPrefix: "",
                                hostname: "atmosly.in",
                                zoneId: "",
                                dnsRecordType: "",
                                loki: true,
                                cloudWatchCollector: false,
                                refreshInterval: "30",
                                objExpiration: "90",
                                hostedZonesList: [],
                                grafanaUser: "",
                                grafanaPassword: ""
                            },
                            k8sDashboard: {
                                recordPrefix: "",
                                hostname: "atmosly.in",
                                zoneId: "",
                                dnsRecordType: "",
                                hostedZonesList: [],
                            },
                            argoFlow: {
                                recordPrefix: "",
                                hostname: "atmosly.in",
                                zoneId: "",
                                dnsRecordType: "",
                                hostedZonesList: [],
                            }
                        }
                    };
                }
                else if (data.data.cluster_data.environment === 'default') {
                    // const pglInfo = addonsData.find(val => val.name === "grafana-stack");
                    const [, pglInfo] = addonsData.find(([key, val]) => key === "grafana-stack") || [];
                    const [, k8sInfo] = addonsData.find(([key, val]) => key === "kubernetes-dashboard") || [];
                    console.log("Data for default addons...", selectedAddons);
                    myData = {
                        id: id,
                        title: data.data.display_name,
                        tabSelected: data.data.cluster_data.environment === 'default' ? 'existingVpc' : data.data.cluster_data.environment,
                        accountId: data.data.target_account_id,
                        integration: data.data.integration_type,
                        integrationId: data.data.cluster_data.cloud_account_id,
                        alias: data.data.target_account_alias,
                        region: data.data.cluster_data.region,
                        nodeExists: data.data.cluster_data.is_node_group_exists || false,
                        accountType: "",
                        zonesAvailable: [],
                        selectedCluster: data.data,
                        isDataFetched: false,
                        accountType: "aws", //needs to be changed for multiple account types
                        availability_zones: isOneClick ? data.data.pre_requsite_data.availability_zones : data.data.cluster_data.availability_zones,
                        vpc: data.data.cluster_data.vpc_id,
                        vpcData: {},
                        prerequisiteInfo: isOneClick ? data.data.pre_requsite_data : {},
                        provisioner: data.data.cluster_data.provisioner,
                        prod: {
                            tags: [{ name: "", value: "" }],
                            naz: [],
                            publicSubnets: [],
                            privateSubnets: [],
                            selectedAddons: [],
                            vpcCidr: "10.0.0.0/16",
                            flowLogMax: "60",    // flow_log_max_aggregation_interval
                            logRetention: "60",    // flow_log_cloudwatch_log_group_retention_in_days
                            clusterLogRetention: "90",    // cluster_log_retention_in_days
                            endpointPublicAccess: true,
                            endpointPrivateAccess: true,
                            publicAccessCidr: "0.0.0.0/0",
                            versionsAvailable: [],
                            addonsData: {},
                            eks: "",
                            hostedZones: [],
                            serverInsType: "",
                            instanceTypeMin: "",
                            instanceTypeMax: "",
                            backups: false,
                            natGatway: true,
                            vpns: true,
                            vpcFlowLogs: true,    // enable_flow_log
                            enableLogTypes: true,
                            addonIds: {},
                            apiServer: false,
                            audit: false,
                            authenticator: false,
                            controllerManager: false,
                            scheduler: false,
                            addons: {
                                argoFlow: true,
                                cert_manager_enabled: true,
                                cert_manager_letsencrypt_email: "",
                                cert_manager_install_letsencrypt_http_issuers: false,
                                enable_karpenter: false,
                                karpenter_provisioner_enabled: false,
                                enable_cluster_autoscaler: true,
                                enable_cluster_propotional_autoscaler: false,
                                enable_single_az_ebs_gp3_storage_class: true,
                                create_efs_storage_class: false,
                                enable_amazon_eks_aws_ebs_csi_driver: true,
                                enable_amazon_eks_vpc_cni: true,
                                create_service_monitor_crd: true,
                                enable_reloader: false,
                                enable_metrics_server: true,
                                enable_ingress_nginx: true,
                                enable_external_secrets: false,
                                enable_keda: false,
                                enable_istio: false,
                                enable_aws_node_termination_handler: true,
                                nginx_alb_controler: false,
                                nginx_ingress_controler: true,
                                pgl_stack: true,
                                k8s_dashboard: false,

                                delete_k8s_dashboard: false //this field will be false by default. It will be true when the user manually disables the enabled k8s dashboard while updating the cluster
                            },
                            updateAddons: {},
                            grafanaStack: {
                                appName: "",
                                recordPrefix: "",
                                hostname: "atmosly.in",
                                zoneId: "",
                                dnsRecordType: "",
                                loki: true,
                                cloudWatchCollector: false,
                                refreshInterval: "30",
                                objExpiration: "90",
                                hostedZonesList: [],
                                grafanaUser: "",
                                grafanaPassword: ""
                            },
                            k8sDashboard: {
                                dnsRecordType: "",
                                hostedZonesList: [],
                                hostname: "atmosly.in",
                                recordPrefix: "",
                                zoneId: "",
                            },
                            argoFlow: {
                                dnsRecordType: "",
                                hostedZonesList: [],
                                hostname: "atmosly.in",
                                recordPrefix: "",
                                zoneId: "",
                            }
                        },
                        "non-prod": {
                            tags: [{ name: "", value: "" }],
                            naz: [],
                            selectedAddons: [],
                            publicSubnets: [],
                            privateSubnets: [],
                            subnets: [],
                            vpcCidr: "10.0.0.0/16",
                            flowLogMax: "600",     // flow_log_max_aggregation_interval
                            logRetention: "60",     // flow_log_cloudwatch_log_group_retention_in_days
                            clusterLogRetention: "90",  // cluster_log_retention_in_days
                            eks: "",
                            hostedZones: [],
                            serverInsType: "",
                            instanceTypeMin: "",
                            instanceTypeMax: "",
                            endpointPublicAccess: true,
                            endpointPrivateAccess: true,
                            publicAccessCidr: "0.0.0.0/0",
                            versionsAvailable: [],
                            addonsData: {},
                            backups: false,
                            natGatway: true,
                            vpns: true,
                            vpcFlowLogs: false,    // enable_flow_log
                            enableLogTypes: false,
                            addonIds: {},
                            apiServer: false,
                            audit: false,
                            authenticator: false,
                            controllerManager: false,
                            scheduler: false,
                            addons: {
                                argoFlow: addonsData.some(val => val.name === "argo-workflow"),
                                cert_manager_enabled: true,
                                cert_manager_letsencrypt_email: "",
                                cert_manager_install_letsencrypt_http_issuers: false,
                                enable_karpenter: false,
                                karpenter_provisioner_enabled: false,
                                enable_cluster_autoscaler: true,
                                enable_cluster_propotional_autoscaler: false,
                                enable_single_az_ebs_gp3_storage_class: true,
                                create_efs_storage_class: false,
                                enable_amazon_eks_aws_ebs_csi_driver: true,
                                enable_amazon_eks_vpc_cni: true,
                                create_service_monitor_crd: true,
                                enable_reloader: false,
                                enable_metrics_server: true,
                                enable_ingress_nginx: true,
                                enable_external_secrets: false,
                                enable_keda: false,
                                enable_istio: false,
                                enable_aws_node_termination_handler: true,
                                nginx_alb_controler: false,
                                nginx_ingress_controler: true,
                                pgl_stack: true,
                                k8s_dashboard: true,

                                delete_k8s_dashboard: false //this field will be false by default. It will be true when the user manually disables the enabled k8s dashboard while updating the cluster
                            },
                            updateAddons: {},
                            grafanaStack: {
                                appName: "",
                                recordPrefix: "",
                                hostname: "atmosly.in",
                                zoneId: "",
                                dnsRecordType: "",
                                loki: true,
                                cloudWatchCollector: false,
                                refreshInterval: "30",
                                objExpiration: "90",
                                hostedZonesList: [],
                                grafanaUser: "",
                                grafanaPassword: ""
                            },
                            k8sDashboard: {
                                dnsRecordType: "",
                                hostedZonesList: [],
                                hostname: "atmosly.in",
                                recordPrefix: "",
                                zoneId: "",
                            },
                            argoFlow: {
                                dnsRecordType: "",
                                hostedZonesList: [],
                                hostname: "atmosly.in",
                                recordPrefix: "",
                                zoneId: "",
                            }
                        },
                        dev: {
                            tags: [{ name: "", value: "" }],
                            naz: [],
                            selectedAddons: [],
                            publicSubnets: [],
                            privateSubnets: [],
                            vpcCidr: "",
                            flowLogMax: "0",
                            logRetention: "60",
                            clusterLogRetention: "90",
                            endpointPublicAccess: true,
                            endpointPrivateAccess: true,
                            publicAccessCidr: "0.0.0.0/0",
                            versionsAvailable: [],
                            addonsData: {},
                            eks: "",
                            hostedZones: [],
                            serverInsType: "",
                            instanceTypeMin: "",
                            instanceTypeMax: "",
                            backups: false,
                            natGatway: false,
                            vpns: false,
                            vpcFlowLogs: false,
                            enableLogTypes: false,
                            addonIds: {},
                            apiServer: false,
                            audit: false,
                            authenticator: false,
                            controllerManager: false,
                            scheduler: false,
                            addons: {
                                argoFlow: true,
                                cert_manager_enabled: true,
                                cert_manager_letsencrypt_email: "",
                                cert_manager_install_letsencrypt_http_issuers: false,
                                enable_karpenter: false,
                                karpenter_provisioner_enabled: false,
                                enable_cluster_autoscaler: true,
                                enable_cluster_propotional_autoscaler: false,
                                enable_single_az_ebs_gp3_storage_class: true,
                                create_efs_storage_class: false,
                                enable_amazon_eks_aws_ebs_csi_driver: true,
                                enable_amazon_eks_vpc_cni: true,
                                create_service_monitor_crd: true,
                                enable_reloader: false,
                                enable_metrics_server: true,
                                enable_ingress_nginx: true,
                                enable_external_secrets: false,
                                enable_keda: false,
                                enable_istio: false,
                                enable_aws_node_termination_handler: true,
                                nginx_alb_controler: false,
                                nginx_ingress_controler: true,
                                pgl_stack: false,
                                k8sDashboard: false
                            },
                            updateAddons: {},
                            grafanaStack: {
                                appName: "",
                                recordPrefix: "",
                                hostname: "atmosly.in",
                                zoneId: "",
                                dnsRecordType: "",
                                loki: true,
                                cloudWatchCollector: false,
                                refreshInterval: "30",
                                objExpiration: "90",
                                hostedZonesList: [],
                                grafanaUser: "",
                                grafanaPassword: ""
                            },
                            k8sDashboard: {
                                dnsRecordType: "",
                                hostedZonesList: [],
                                hostname: "atmosly.in",
                                recordPrefix: "",
                                zoneId: "",
                            },
                            argoFlow: {
                                dnsRecordType: "",
                                hostedZonesList: [],
                                hostname: "atmosly.in",
                                recordPrefix: "",
                                zoneId: "",
                            }
                        },
                        existingVpc: {
                            tags: Object.entries(data.data.cluster_data.tags).map(([key, value]) => ({
                                name: key,
                                value: value
                            })),
                            selectedAddons: selectedAddons,
                            naz: data.data.cluster_data.availability_zones,
                            publicSubnets: [],
                            privateSubnets: data.data.cluster_data.private_subnet_ids,
                            subnets: data.data.cluster_data.private_subnet_ids,
                            hostedZones: [],
                            vpcCidr: "10.0.0.0/16",
                            flowLogMax: "60",    // flow_log_max_aggregation_interval
                            logRetention: "60",    // flow_log_cloudwatch_log_group_retention_in_days
                            clusterLogRetention: "90",    // cluster_log_retention_in_days
                            endpointPublicAccess: isOneClick ? true : data.data.cluster_data.cluster_endpoint_public_access,
                            endpointPrivateAccess: isOneClick ? true : data.data.cluster_data.cluster_endpoint_private_access,
                            publicAccessCidr: "0.0.0.0/0",
                            versionsAvailable: [],
                            addonsData: {},
                            eks: data.data.cluster_data.kubernetes_version,
                            cluster_version_id: data.data.cluster_data.cluster_version_id,
                            serverInsType: "",
                            instanceTypeMin: "",
                            instanceTypeMax: "",
                            backups: false,
                            natGatway: true,
                            vpns: true,
                            vpcFlowLogs: false,    // enable_flow_log
                            enableLogTypes: true,
                            addonIds: {},
                            apiServer: false,
                            audit: false,
                            authenticator: false,
                            controllerManager: false,
                            scheduler: false,
                            addons: {
                                argoFlow: addonsData.some(val => val.name === "argo-workflow"),
                                cert_manager_enabled: addonsData.some(val => val.name === "Cert Manager"),
                                cert_manager_letsencrypt_email: "",
                                cert_manager_install_letsencrypt_http_issuers: false,
                                enable_karpenter: false,
                                karpenter_provisioner_enabled: false,
                                enable_cluster_autoscaler: true,
                                enable_cluster_propotional_autoscaler: false,
                                enable_single_az_ebs_gp3_storage_class: true,
                                create_efs_storage_class: addonsData.some(val => val.name === "EFS Storage Class"),
                                enable_amazon_eks_aws_ebs_csi_driver: true,
                                enable_amazon_eks_vpc_cni: true,
                                create_service_monitor_crd: true,
                                enable_reloader: addonsData.some(val => val.name === "Reloader"),
                                enable_metrics_server: true,
                                enable_ingress_nginx: true,
                                enable_external_secrets: false,
                                enable_keda: addonsData.some(val => val.name === "Keda"),
                                enable_istio: false,
                                enable_aws_node_termination_handler: true,
                                nginx_alb_controler: addonsData.some(val => val.name === "Ingress ALB Controller"),
                                nginx_ingress_controler: addonsData.some(val => val.name === "Nginx Ingress Controller"),
                                pgl_stack: pglInfo ? true : false,
                                k8s_dashboard: k8sInfo ? true : false,

                                delete_k8s_dashboard: false
                                // cert_manager_enabled: false,
                                // cert_manager_letsencrypt_email: "",
                                // cert_manager_install_letsencrypt_http_issuers: false,
                                // enable_karpenter: false,
                                // karpenter_provisioner_enabled: false,
                                // enable_cluster_autoscaler: true,
                                // enable_cluster_propotional_autoscaler: false,
                                // enable_single_az_ebs_gp3_storage_class: true,
                                // create_efs_storage_class: false,
                                // enable_amazon_eks_aws_ebs_csi_driver: true,
                                // enable_amazon_eks_vpc_cni: true,
                                // create_service_monitor_crd: true,
                                // enable_reloader: false,
                                // enable_metrics_server: true,
                                // enable_ingress_nginx: true,
                                // enable_external_secrets: false,
                                // enable_keda: false,
                                // enable_istio: false,
                                // enable_aws_node_termination_handler: true,
                                // nginx_alb_controler: false,
                                // nginx_ingress_controler: true,
                                // pgl_stack: true,
                                // k8s_dashboard: true,
                                // argoFlow: true,

                                // delete_k8s_dashboard: false //this field will be false by default. It will be true when the user manually disables the enabled k8s dashboard while updating the cluster
                            },
                            updateAddons: {
                                pgl_stack: pglInfo ? true : false,
                            },
                            grafanaStack: {
                                appName: isOneClick ? "" : pglInfo?.user_values?.app_name,
                                recordPrefix: isOneClick ? "" : pglInfo?.user_values?.record_prefix,
                                hostname: isOneClick ? "atmosly.in" : pglInfo?.user_values?.hosted_zone || "atmosly.in",
                                zoneId: isOneClick ? "" : pglInfo?.user_values?.zone_id,
                                dnsRecordType: isOneClick ? "" : pglInfo?.user_values?.dns_record_type,
                                loki: isOneClick ? true : pglInfo?.user_values?.loki_enabled === false ? false : true,
                                // cloudWatchCollector: isOneClick ? true : pglInfo?.user_values?.cloudwatch_enabled === false ? false : true,
                                cloudWatchCollector: pglInfo?.user_values?.cloudwatch_enabled === true ? true : false,
                                refreshInterval: isOneClick ? "30" : pglInfo?.user_values?.dashboard_refresh_interval?.split("s")[0] || "30",
                                objExpiration: "90",
                                hostedZonesList: [],
                                grafanaUser: isOneClick ? "" : pglInfo?.user_values?.grafana_user || "",
                                grafanaPassword: isOneClick ? "" : pglInfo?.user_values?.grafana_password || "",
                                // grafana toggle, node placement and Prometheus/Grafana
                                // resource sizing — hydrated from the saved user_values so
                                // the edit drawer reflects what was actually installed.
                                grafanaEnabled: isOneClick ? true : (pglInfo?.user_values?.grafana_enabled === false || pglInfo?.user_values?.grafana_enabled === "false") ? false : true,
                                nodeSelectorKey: isOneClick ? "" : Object.keys(pglInfo?.user_values?.node_selector || {})[0] || "",
                                nodeSelectorValue: isOneClick ? "" : Object.values(pglInfo?.user_values?.node_selector || {})[0] || "",
                                promCpuRequest: isOneClick ? "" : pglInfo?.user_values?.prometheus_cpu_request || "",
                                promCpuLimit: isOneClick ? "" : pglInfo?.user_values?.prometheus_cpu_limit || "",
                                promMemRequest: isOneClick ? "" : pglInfo?.user_values?.prometheus_memory_request || "",
                                promMemLimit: isOneClick ? "" : pglInfo?.user_values?.prometheus_memory_limit || "",
                                promStorage: isOneClick ? "" : pglInfo?.user_values?.prometheus_storage_size || "",
                                promRetention: isOneClick ? "" : pglInfo?.user_values?.prometheus_retention || "",
                                grafanaCpuRequest: isOneClick ? "" : pglInfo?.user_values?.grafana_cpu_request || "",
                                grafanaCpuLimit: isOneClick ? "" : pglInfo?.user_values?.grafana_cpu_limit || "",
                                grafanaMemRequest: isOneClick ? "" : pglInfo?.user_values?.grafana_memory_request || "",
                                grafanaMemLimit: isOneClick ? "" : pglInfo?.user_values?.grafana_memory_limit || "",
                            },
                            k8sDashboard: {
                                dnsRecordType: isOneClick ? "" : k8sInfo?.user_values?.dns_record_type || 'cloudflare',
                                hostedZonesList: [],
                                hostname: isOneClick ? "atmosly.in" : k8sInfo?.user_values?.dns_record_id || 'atmosly.in',
                                recordPrefix: isOneClick ? "" : k8sInfo?.user_values?.record_prefix || "k8s-dashboard",
                                zoneId: isOneClick ? "" : k8sInfo?.user_values?.zone_id,
                            },
                            argoFlow: {
                                dnsRecordType: data.data?.addons_data['argo-workflow']?.user_values?.dns_record_type,
                                hostedZonesList: [],
                                hostname: data.data?.addons_data['argo-workflow']?.user_values?.hosted_zone,
                                recordPrefix: data.data?.addons_data['argo-workflow']?.user_values?.record_prefix,
                                zoneId: data.data?.addons_data['argo-workflow']?.user_values?.zone_id,
                            }
                        }
                    };
                    // myData=selectedAddons
                    console.log('mydata in use: ', myData);
                }
                else {
                    const [, pglInfo] = addonsData.find(([key, val]) => key === "grafana-stack") || [];
                    const [, k8sInfo] = addonsData.find(([key, val]) => key === "kubernetes-dashboard") || [];
                    console.log("pglInfo: ", pglInfo)

                    myData = {
                        id: id,
                        title: data.data.display_name,
                        accountId: data.data.target_account_id,
                        integration: data.data.integration_type,
                        integrationId: isUpdate ? updateCluster.integrationId : data.data.cluster_data.integration_id,
                        alias: data.data.target_account_alias,
                        region: data.data.cluster_data.region,
                        nodeExists: data.data.cluster_data.is_node_group_exists || false,
                        accountType: "",
                        zonesAvailable: [],
                        selectedCluster: data.data,
                        isDataFetched: false,
                        accountType: "aws", //needs to be changed for multiple account types
                        availability_zones: isOneClick ? data.data.pre_requsite_data.availability_zones : [],
                        vpc: "Create New VPC",
                        vpcData: {},
                        prerequisiteInfo: isOneClick ? data.data.pre_requsite_data : {},
                        provisioner: data.data.cluster_data.provisioner,
                        prod: {
                            tags: [{ name: "", value: "" }],
                            naz: [],
                            selectedAddons: [],
                            privateSubnets: [],
                            publicSubnets: [],
                            vpcCidr: "10.0.0.0/16",
                            subnets: [],
                            flowLogMax: "60",    // flow_log_max_aggregation_interval
                            logRetention: "60",    // flow_log_cloudwatch_log_group_retention_in_days
                            clusterLogRetention: "90",    // cluster_log_retention_in_days
                            endpointPublicAccess: true,
                            endpointPrivateAccess: true,
                            publicAccessCidr: "0.0.0.0/0",
                            versionsAvailable: [],
                            addonsData: {},
                            eks: "",
                            hostedZones: [],
                            serverInsType: "",
                            instanceTypeMin: "",
                            instanceTypeMax: "",
                            backups: false,
                            natGatway: true,
                            vpns: true,
                            vpcFlowLogs: true,    // enable_flow_log
                            enableLogTypes: true,
                            addonIds: {},
                            apiServer: false,
                            audit: false,
                            authenticator: false,
                            controllerManager: false,
                            scheduler: false,
                            addons: {
                                argoFlow: true,
                                cert_manager_enabled: true,
                                cert_manager_letsencrypt_email: "",
                                cert_manager_install_letsencrypt_http_issuers: false,
                                enable_karpenter: false,
                                karpenter_provisioner_enabled: false,
                                enable_cluster_autoscaler: true,
                                enable_cluster_propotional_autoscaler: false,
                                enable_single_az_ebs_gp3_storage_class: true,
                                create_efs_storage_class: false,
                                enable_amazon_eks_aws_ebs_csi_driver: true,
                                enable_amazon_eks_vpc_cni: true,
                                create_service_monitor_crd: true,
                                enable_reloader: false,
                                enable_metrics_server: true,
                                enable_ingress_nginx: true,
                                enable_external_secrets: false,
                                enable_keda: false,
                                enable_istio: false,
                                enable_aws_node_termination_handler: true,
                                nginx_alb_controler: false,
                                nginx_ingress_controler: true,
                                pgl_stack: true,
                                k8s_dashboard: false,

                                delete_k8s_dashboard: false //this field will be false by default. It will be true when the user manually disables the enabled k8s dashboard while updating the cluster
                            },
                            updateAddons: {},
                            grafanaStack: {
                                appName: "",
                                recordPrefix: "",
                                hostname: "atmosly.in",
                                zoneId: "",
                                dnsRecordType: "",
                                loki: true,
                                cloudWatchCollector: false,
                                refreshInterval: "30",
                                objExpiration: "90",
                                hostedZonesList: [],
                                grafanaUser: "",
                                grafanaPassword: ""
                            },
                            k8sDashboard: {
                                dnsRecordType: "",
                                hostedZonesList: [],
                                hostname: "atmosly.in",
                                recordPrefix: "",
                                zoneId: "",
                            },
                            argoFlow: {
                                dnsRecordType: "",
                                hostedZonesList: [],
                                hostname: "atmosly.in",
                                recordPrefix: "",
                                zoneId: "",
                            }
                        },
                        "non-prod": {
                            tags: tags,
                            naz: isOneClick ? [data.data.cluster_data.availability_zones] : data.data.cluster_data.availability_zones,
                            selectedAddons: selectedAddons,
                            publicSubnets: [],
                            privateSubnets: [],
                            subnets: [],
                            vpcCidr: data.data.cluster_data.vpc_cidr_block,
                            flowLogMax: "60",     // flow_log_max_aggregation_interval
                            logRetention: data.data.cluster_data.vpc_flow_log ? data.data.cluster_data.vpc_flow_log_retention_period : "60",    // flow_log_cloudwatch_log_group_retention_in_days
                            clusterLogRetention: data.data.cluster_data.vpc_flow_log ? data.data.cluster_data.kubernetes_log_retention_period : "90",    // flow_log_cloudwatch_log_group_retention_in_days
                            eks: data.data.cluster_data.kubernetes_version,
                            hostedZones: isUpdate ? [] : oneClickCluster[data.data.cluster_data.environment].hostedZones,
                            serverInsType: "",
                            instanceTypeMin: "",
                            instanceTypeMax: "",
                            endpointPublicAccess: isOneClick ? true : data.data.cluster_data.cluster_endpoint_public_access,
                            endpointPrivateAccess: isOneClick ? true : data.data.cluster_data.cluster_endpoint_private_access,
                            publicAccessCidr: "0.0.0.0/0",
                            versionsAvailable: [],
                            addonsData: {},
                            backups: false,
                            natGatway: true,
                            vpns: true,
                            // vpcFlowLogs: data.data.cluster_data.vpc_flow_logs === "true" ? true : false,    // enable_flow_log
                            vpcFlowLogs: data.data.cluster_data.vpc_flow_log || false,    // enable_flow_log
                            enableLogTypes: false,
                            addonIds: {},
                            apiServer: isOneClick ? false : data.data.cluster_data.cluster_enabled_log_types ? data.data.cluster_data.cluster_enabled_log_types.includes("api") : false,
                            audit: isOneClick ? false : data.data.cluster_data.cluster_enabled_log_types ? data.data.cluster_data.cluster_enabled_log_types.includes("audit") : false,
                            authenticator: isOneClick ? false : data.data.cluster_data.cluster_enabled_log_types ? data.data.cluster_data.cluster_enabled_log_types.includes("authenticator") : false,
                            controllerManager: isOneClick ? false : data.data.cluster_data.cluster_enabled_log_types ? data.data.cluster_data.cluster_enabled_log_types.includes("controllerManager") : false,
                            scheduler: isOneClick ? false : data.data.cluster_data.cluster_enabled_log_types ? data.data.cluster_data.cluster_enabled_log_types.includes("scheduler") : false,
                            addons: {
                                argoFlow: addonsData.some(val => val.name === "argo-workflow"),
                                cert_manager_enabled: addonsData.some(val => val.name === "Cert Manager"),
                                cert_manager_letsencrypt_email: "",
                                cert_manager_install_letsencrypt_http_issuers: false,
                                enable_karpenter: false,
                                karpenter_provisioner_enabled: false,
                                enable_cluster_autoscaler: true,
                                enable_cluster_propotional_autoscaler: false,
                                enable_single_az_ebs_gp3_storage_class: true,
                                create_efs_storage_class: addonsData.some(val => val.name === "EFS Storage Class"),
                                enable_amazon_eks_aws_ebs_csi_driver: true,
                                enable_amazon_eks_vpc_cni: true,
                                create_service_monitor_crd: true,
                                enable_reloader: addonsData.some(val => val.name === "Reloader"),
                                enable_metrics_server: true,
                                enable_ingress_nginx: true,
                                enable_external_secrets: false,
                                enable_keda: addonsData.some(val => val.name === "Keda"),
                                enable_istio: false,
                                enable_aws_node_termination_handler: true,
                                nginx_alb_controler: addonsData.some(val => val.name === "Ingress ALB Controller"),
                                nginx_ingress_controler: addonsData.some(val => val.name === "Nginx Ingress Controller"),
                                pgl_stack: pglInfo ? true : false,
                                k8s_dashboard: k8sInfo ? true : false,

                                delete_k8s_dashboard: false //this field will be false by default. It will be true when the user manually disables the enabled k8s dashboard while updating the cluster
                            },
                            updateAddons: {
                                pgl_stack: pglInfo ? true : false,
                            },
                            grafanaStack: {
                                appName: isOneClick ? "" : pglInfo?.user_values?.app_name,
                                recordPrefix: isOneClick ? "" : pglInfo?.user_values?.record_prefix,
                                hostname: isOneClick ? "atmosly.in" : pglInfo?.user_values?.hosted_zone || "atmosly.in",
                                zoneId: isOneClick ? "" : pglInfo?.user_values?.zone_id,
                                dnsRecordType: isOneClick ? "" : pglInfo?.user_values?.dns_record_type,
                                loki: isOneClick ? true : pglInfo?.user_values?.loki_enabled === false ? false : true,
                                // cloudWatchCollector: isOneClick ? true : pglInfo?.user_values?.cloudwatch_enabled === false ? false : true,
                                cloudWatchCollector: pglInfo?.user_values?.cloudwatch_enabled === true ? true : false,
                                refreshInterval: isOneClick ? "30" : pglInfo?.user_values?.dashboard_refresh_interval?.split("s")[0] || "30",
                                objExpiration: "90",
                                hostedZonesList: [],
                                grafanaUser: isOneClick ? "" : pglInfo?.user_values?.grafana_user || "",
                                grafanaPassword: isOneClick ? "" : pglInfo?.user_values?.grafana_password || "",
                                // grafana toggle, node placement and Prometheus/Grafana
                                // resource sizing — hydrated from the saved user_values so
                                // the edit drawer reflects what was actually installed.
                                grafanaEnabled: isOneClick ? true : (pglInfo?.user_values?.grafana_enabled === false || pglInfo?.user_values?.grafana_enabled === "false") ? false : true,
                                nodeSelectorKey: isOneClick ? "" : Object.keys(pglInfo?.user_values?.node_selector || {})[0] || "",
                                nodeSelectorValue: isOneClick ? "" : Object.values(pglInfo?.user_values?.node_selector || {})[0] || "",
                                promCpuRequest: isOneClick ? "" : pglInfo?.user_values?.prometheus_cpu_request || "",
                                promCpuLimit: isOneClick ? "" : pglInfo?.user_values?.prometheus_cpu_limit || "",
                                promMemRequest: isOneClick ? "" : pglInfo?.user_values?.prometheus_memory_request || "",
                                promMemLimit: isOneClick ? "" : pglInfo?.user_values?.prometheus_memory_limit || "",
                                promStorage: isOneClick ? "" : pglInfo?.user_values?.prometheus_storage_size || "",
                                promRetention: isOneClick ? "" : pglInfo?.user_values?.prometheus_retention || "",
                                grafanaCpuRequest: isOneClick ? "" : pglInfo?.user_values?.grafana_cpu_request || "",
                                grafanaCpuLimit: isOneClick ? "" : pglInfo?.user_values?.grafana_cpu_limit || "",
                                grafanaMemRequest: isOneClick ? "" : pglInfo?.user_values?.grafana_memory_request || "",
                                grafanaMemLimit: isOneClick ? "" : pglInfo?.user_values?.grafana_memory_limit || "",
                            },
                            k8sDashboard: {
                                dnsRecordType: isOneClick ? "" : k8sInfo?.user_values?.dns_record_type,
                                hostedZonesList: [],
                                hostname: isOneClick ? "atmosly.in" : k8sInfo?.user_values?.hosted_zone || "atmosly.in",
                                recordPrefix: isOneClick ? "" : k8sInfo?.user_values?.record_prefix,
                                zoneId: isOneClick ? "" : k8sInfo?.user_values?.zone_id,
                            },
                            argoFlow: {
                                dnsRecordType: data.data?.addons_data['argo-workflow']?.user_values?.dns_record_type,
                                hostedZonesList: [],
                                hostname: data.data?.addons_data['argo-workflow']?.user_values?.hosted_zone,
                                recordPrefix: data.data?.addons_data['argo-workflow']?.user_values?.record_prefix,
                                zoneId: data.data?.addons_data['argo-workflow']?.user_values?.zone_id,
                            }
                        },
                        dev: {
                            tags: [{ name: "", value: "" }],
                            naz: [],
                            selectedAddons: [],
                            publicSubnets: [],
                            privateSubnets: [],
                            subnets: [],
                            vpcCidr: "",
                            flowLogMax: "0",
                            logRetention: "60",
                            clusterLogRetention: "90",
                            endpointPublicAccess: true,
                            endpointPrivateAccess: true,
                            publicAccessCidr: "0.0.0.0/0",
                            versionsAvailable: [],
                            addonsData: {},
                            eks: "",
                            hostedZones: [],
                            serverInsType: "",
                            instanceTypeMin: "",
                            instanceTypeMax: "",
                            backups: false,
                            natGatway: false,
                            vpns: false,
                            vpcFlowLogs: false,
                            enableLogTypes: false,
                            addonIds: {},
                            apiServer: false,
                            audit: false,
                            authenticator: false,
                            controllerManager: false,
                            scheduler: false,
                            addons: {
                                argoFlow: true,
                                cert_manager_enabled: true,
                                cert_manager_letsencrypt_email: "",
                                cert_manager_install_letsencrypt_http_issuers: false,
                                enable_karpenter: false,
                                karpenter_provisioner_enabled: false,
                                enable_cluster_autoscaler: true,
                                enable_cluster_propotional_autoscaler: false,
                                enable_single_az_ebs_gp3_storage_class: true,
                                create_efs_storage_class: false,
                                enable_amazon_eks_aws_ebs_csi_driver: true,
                                enable_amazon_eks_vpc_cni: true,
                                create_service_monitor_crd: true,
                                enable_reloader: false,
                                enable_metrics_server: true,
                                enable_ingress_nginx: true,
                                enable_external_secrets: false,
                                enable_keda: false,
                                enable_istio: false,
                                enable_aws_node_termination_handler: true,
                                nginx_alb_controler: false,
                                nginx_ingress_controler: true,
                                pgl_stack: false,
                                k8sDashboard: false
                            },
                            updateAddons: {},
                            grafanaStack: {
                                appName: "",
                                hostname: "",
                                loki: false,
                                cloudWatchCollector: false,
                                hostname: "",
                                objExpiration: "",
                                hostedZonesList: [],
                                grafanaUser: "",
                                grafanaPassword: ""
                            },
                            k8sDashboard: {
                                dnsRecordType: "",
                                hostedZonesList: [],
                                hostname: "atmosly.in",
                                recordPrefix: "",
                                zoneId: "",
                            },
                            argoFlow: {
                                dnsRecordType: "",
                                hostedZonesList: [],
                                hostname: "atmosly.in",
                                recordPrefix: "",
                                zoneId: "",
                            }
                        },
                        existingVpc: {
                            tags: [{ name: "", value: "" }],
                            selectedAddons: [],
                            naz: [],
                            publicSubnets: [],
                            privateSubnets: [],
                            subnets: [],
                            hostedZones: [],
                            vpcCidr: "10.0.0.0/16",
                            flowLogMax: "60",    // flow_log_max_aggregation_interval
                            logRetention: "60",    // flow_log_cloudwatch_log_group_retention_in_days
                            clusterLogRetention: "90",    // cluster_log_retention_in_days
                            endpointPublicAccess: true,
                            endpointPrivateAccess: true,
                            publicAccessCidr: "0.0.0.0/0",
                            versionsAvailable: [],
                            addonsData: {},
                            eks: "",
                            serverInsType: "",
                            instanceTypeMin: "",
                            instanceTypeMax: "",
                            backups: false,
                            natGatway: true,
                            vpns: true,
                            vpcFlowLogs: true,    // enable_flow_log
                            enableLogTypes: true,
                            addonIds: {},
                            apiServer: false,
                            audit: false,
                            authenticator: false,
                            controllerManager: false,
                            scheduler: false,
                            addons: {
                                cert_manager_enabled: false,
                                cert_manager_letsencrypt_email: "",
                                cert_manager_install_letsencrypt_http_issuers: false,
                                enable_karpenter: false,
                                karpenter_provisioner_enabled: false,
                                enable_cluster_autoscaler: true,
                                enable_cluster_propotional_autoscaler: false,
                                enable_single_az_ebs_gp3_storage_class: true,
                                create_efs_storage_class: false,
                                enable_amazon_eks_aws_ebs_csi_driver: true,
                                enable_amazon_eks_vpc_cni: true,
                                create_service_monitor_crd: true,
                                enable_reloader: false,
                                enable_metrics_server: true,
                                enable_ingress_nginx: true,
                                enable_external_secrets: false,
                                enable_keda: false,
                                enable_istio: false,
                                enable_aws_node_termination_handler: true,
                                nginx_alb_controler: false,
                                nginx_ingress_controler: true,
                                pgl_stack: true,
                                k8s_dashboard: true,
                                argoFlow: true,

                                delete_k8s_dashboard: false //this field will be false by default. It will be true when the user manually disables the enabled k8s dashboard while updating the cluster
                            },
                            grafanaStack: {
                                appName: "",
                                recordPrefix: "",
                                hostname: "atmosly.in",
                                zoneId: "",
                                dnsRecordType: "",
                                loki: true,
                                cloudWatchCollector: false,
                                refreshInterval: "30",
                                objExpiration: "90",
                                hostedZonesList: [],
                                grafanaUser: "",
                                grafanaPassword: ""
                            },
                            k8sDashboard: {
                                recordPrefix: "",
                                hostname: "atmosly.in",
                                zoneId: "",
                                dnsRecordType: "",
                                hostedZonesList: [],
                            },
                            argoFlow: {
                                recordPrefix: "",
                                hostname: "atmosly.in",
                                zoneId: "",
                                dnsRecordType: "",
                                hostedZonesList: [],
                            }
                        }
                    };
                }
                console.log("Updated myData: ", myData);
                //return myData;
            }
            else {
                throw new Error(data.error_details);
            }
        }).catch((err) => {
            console.log("Error", err);
            throw err;
            //return {};
        });
        console.log("My data: ", myData);
        return myData;
    }
    //}
    const fetchAddons = async (myData) => {
        if (myData.provisioner !== 'imported') {
            return;
        }
        let tabSelected = myData.tabSelected;
        console.log('tab selected: ', tabSelected);
        let result = myData[tabSelected].cluster_version_id;
        await api.get(process.env.REACT_APP_API_URI + `/api/cluster/fetch-addons?cloud=${myData.accountType}&cluster_version=${myData[tabSelected].eks}`)
            .then(async (res) => {
                let resData = await res.data;
                if (resData.data) {
                    myData[tabSelected]["addonsData"] = resData;
                    console.log('my cluster data end: ', myData);
                    setUpdateCluster({ ...myData, [tabSelected]: myData[tabSelected] });
                    localStorage.setItem('updateCluster', JSON.stringify(myData))
                }
                console.log("This is the addons data: ", resData);
            })
            .catch((err) => {
                console.log("Something went wrong in cluster-addons api :", err);
                // myClusterData[tabSelected]["addonsData"] = { data: {} };
                if (isUpdate) {
                    setUpdateCluster({ ...myData, [tabSelected]: myData[tabSelected] });
                }
            });
    }
    return { fetchClusterData, fetchAddons };
}
